export default "__VITE_ASSET__RBlKERvW__"